export * from './baBackTop.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baBackTop/index.ts